<template>
  <p v-html="title"></p>
</template>

<script setup>
import { computed, onBeforeMount } from 'vue'
import { useStore } from '../../stores/main'

const store = useStore()
const props = defineProps({
  archiveType: {
    type: String,
    required: true,
  },
  archiveId: {
    type: [Object, Number],
    required: true,
  },
})

const request = computed(() => {
  return {
    type: props.archiveType,
    id: props.archiveType === 'users' ? props.archiveId.id : props.archiveId,
    batch: true,
  }
})

const item = computed(() => {
  return store.singleById(request.value)
})

const title = computed(() => {
  return item.value ? item.value.name : ''
})

const getArchiveItem = () => store.getSingleById(request.value)

onBeforeMount(() => getArchiveItem())
</script>
